import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "page-header__item page-header__item--logo" };
const _hoisted_2 = { class: "page-header__item page-header__item--nav" };
const _hoisted_3 = { class: "page-header__item page-header__item--user" };
const _hoisted_4 = { class: "page-header__item page-header__item--context" };
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import Navigation from "./Navigation.vue";
import { useClickaway } from "../composables/clickaway";
import Icon from "./Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppHeader',
    props: {
        navItems: {},
        variant: {},
        navVariant: {}
    },
    setup(__props) {
        const navigationEl = ref(null);
        onMounted(() => useClickaway(navigationEl, hideMainNav));
        // only relevant on mobile
        const openMainNav = ref(false);
        const justOpened = ref(false);
        const route = useRoute();
        watch(() => route.path, () => {
            // close main nav on navigation on mobile
            openMainNav.value = false;
        });
        function toggleMainNav() {
            openMainNav.value = !openMainNav.value;
            justOpened.value = openMainNav.value;
            window.setTimeout(() => {
                justOpened.value = false;
            }, 100);
        }
        function hideMainNav() {
            if (!justOpened.value) {
                openMainNav.value = false;
            }
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("header", {
                class: _normalizeClass(["page-header page-header--inline", 'page-header--' + __props.variant])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_router_link, {
                        to: "/",
                        class: "page-header__logo"
                    })
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (toggleMainNav()), ["prevent"])),
                        class: "page-header__mobile-nav-toggle",
                        href: ""
                    }, [
                        _createVNode(Icon, { name: "bars" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$te('nav.menu') ? _ctx.$t('nav.menu') : ''), 1)
                    ]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createVNode(Navigation, {
                        items: __props.navItems,
                        type: "main",
                        variant: __props.navVariant,
                        class: _normalizeClass({ 'main-nav--open': openMainNav.value }),
                        ref_key: "navigationEl",
                        ref: navigationEl
                    }, null, 8, ["items", "variant", "class"])
                ]),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "user")
                ]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "context")
                ])
            ], 2));
        };
    }
});
